export const createPaymentIntent = `
    mutation createPaymentIntent($input: CreatePaymentIntentInput!) {
        createPaymentIntent(input:$input) {
              id
              amount
              currency
              customerId
              description
              clientSecret
              status
              created
        }
}`;

export const updatePaymentIntent = `
    mutation updatePaymentIntent($input: UpdatePaymentIntentInput!) {
        updatePaymentIntent(input:$input){
              id
              amount
              currency
              customerId
              description
              clientSecret
              status
        }
}`;

export const deletePaymentIntent = `
    mutation deletePaymentIntent($input: DeletePaymentIntentInput!) {
        deletePaymentIntent(input:$input) 
}`;
